module.exports = __webpack_public_path__ + "fonts/Ubuntu-Italic.4b96047e.ttf";